import { ReactElement, useContext } from 'react';
import cs from 'classnames';
import { Button } from 'antd';

import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import { SidebarContext } from 'contexts/sidebarContext';

import Authentication from 'components/Authentication';

import styles from './Sidebar.module.scss';

const Sidebar = (): ReactElement => {
  const { setShowSidebar, showSidebar } = useContext(SidebarContext);

  return (
    <>
      {showSidebar && <div className={styles.overlay} />}
      <div className={cs(styles.container, { [styles.show]: showSidebar })}>
        <Button
          className={styles.closeButton}
          onClick={() => setShowSidebar(false)}
        >
          <CloseIcon />
        </Button>
        <Authentication />
      </div>
    </>
  );
};

export default Sidebar;
